/* -----------------------------------*\
        table of content
    \*------------------------------------*/

function slugify(text) {
    return text.toString().toLowerCase().replace(/\s+/g, '-');
}

const articleContent = document.querySelector('.single .article');
let headings = articleContent.querySelectorAll('h2');
let header = document.querySelector('.rheader-new');
if (header === null) {
    header = document.querySelector('.rheader');
}
if (headings.length > 0) {
    document.querySelector('.single aside').classList.remove('empty');
}

headings = [].filter.call(headings, (heading) => {
    if (heading.getBoundingClientRect().width > 0) {
        return true;
    }
    return false;
});

function createId() {
    return new Promise((resolve) => {
        [].forEach.call(headings, (heading) => {
            const headerId = slugify(heading.innerText);

            heading.setAttribute('id', headerId);
        });
        resolve(true);
    });
}

createId().then(() => {
    if (window.location.hash) {
        const target = window.location.hash.split('#');
        const idSection = document.getElementById(target[1]);
        if (idSection !== null) {
            window.scrollTo({
                top: idSection.offsetTop - header.offsetHeight - 20,
                behavior: 'smooth',
            });
        }
    }
});

const tableOfContentList = document.querySelector('.category-contents .list ul');

[].forEach.call(headings, (heading) => {
    const headerId = heading.getAttribute('id');
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('href', `#${headerId}`);
    a.innerText = heading.innerText;
    a.addEventListener('click', function onToCLinkClick(event) {
        event.preventDefault();
        window.scrollTo({
            top: document.getElementById(this.getAttribute('href').substring(1)).offsetTop - header.offsetHeight - 20,
            behavior: 'smooth',
        });
    });
    li.appendChild(a);

    tableOfContentList.appendChild(li);
});

[].forEach.call(document.querySelectorAll('[data-tooltip="glossary"]'), (popupTrigger) => {
    const tooltipPopup = document.querySelector('.tooltip-popup').cloneNode(true);
    popupTrigger.appendChild(tooltipPopup);
    popupTrigger.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() !== 'a' || e.target === popupTrigger) {
            e.preventDefault();
        }
        if (e.target.classList.contains('close')) {
            tooltipPopup.style.display = 'none';
        }
    });
    popupTrigger.addEventListener('mouseover', (_e) => {
        if (!popupTrigger.querySelector('tooltip-body')) {
            tooltipPopup.style.display = '';
            const request = new XMLHttpRequest();
            const url = `${popupTrigger.getAttribute('href')}?tool=tip`;
            request.open('GET', url.replace(/https:\/\/[a-z\.]+\//, '/'), true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    tooltipPopup.innerHTML = this.response;
                    tooltipPopup.classList.remove('loading');
                }
            };
            request.send();
        }
    });

    // popupTrigger.addEventListener('mouseout', (e) => {
    //     tooltipPopup.style.display = 'none';
    // });
});
